<template>
	<div>
		<b-row>
			<b-col>
				<b-form>
					<!-- <b-row>
						<b-col xl="4" lg="4" sm="4">
							<p class="mt-3">
								<span class="h3">Group</span>
							</p>
						</b-col>
						<b-col xl="8" lg="8" sm="8">
							<b-form-group label-for="input-1">
								<b-form-select
									id="linkGroup"
									v-model="linkUpdateForm.group"
									:options="groupOption"
									:state="groupStatus"
									value-field="key"
									class="mt-2 mb-0"
									text-field="text"
									disabled
									@change="getCarrierLinks"
								></b-form-select>
								<b-form-invalid-feedback :state="groupStatus">
									Please select a valid group
								</b-form-invalid-feedback>
							</b-form-group>
						</b-col>
					</b-row> -->
					<!-- <b-row>
						<b-col xl="4" lg="4" sm="4">
							<p class="mt-3">
								<span class="h3">Type</span>
							</p>
						</b-col>
						<b-col xl="8" lg="8" sm="8">
							<b-form-group label-for="input-1">
								<b-form-select
									id="linkType"
									v-model="linkUpdateForm.type"
									:options="typeOption"
									:state="typeStatus"
									value-field="key"
									@change="handleTypeChange"
								>
								</b-form-select>
								<b-form-invalid-feedback :state="typeStatus">
									Please select a link type
								</b-form-invalid-feedback>
							</b-form-group>
						</b-col>
					</b-row> -->
					<!-- <b-row>
						<b-col xl="4" lg="4" sm="4">
							<p class="mt-3">
								<span class="h3">Link</span>
							</p>
						</b-col>
						<b-col xl="8" lg="8" sm="8">
							<b-form-group v-if="linkUpdateForm.type.includes('external')" label-for="input-1">
								<b-form-input
									id="externalUrl"
									v-model="linkUpdateForm.link"
									:state="linkStatus"
								></b-form-input>
								<b-form-invalid-feedback :state="linkStatus">
									Please enter the exernal resource URL
								</b-form-invalid-feedback>
							</b-form-group>
							<b-form-group v-else label-for="input-1">
								<b-form-select
									id="input-1"
									:state="linkStatus"
									v-model="linkUpdateForm.link"
									:options="groupLinks"
									value-field="url"
									text-field="label"
									@change="handleRouteChange"
								></b-form-select>
								<b-form-invalid-feedback :state="linkStatus">
									Please select a path
								</b-form-invalid-feedback>
							</b-form-group>
						</b-col>
					</b-row> -->
					<b-row>
						<b-col xl="4" lg="4" sm="4">
							<p class="mt-3">
								<span class="h3">Name</span>
							</p>
						</b-col>
						<b-col xl="8" lg="8" sm="8">
							<b-form-group label-for="input-1">
								<b-form-input
									id="input-1"
									v-model="linkUpdateForm.name"
									:state="nameStatus"
								></b-form-input>
								<b-form-invalid-feedback :state="nameStatus">
									Please enter a link name
								</b-form-invalid-feedback>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col xl="4" lg="4" sm="4">
							<p class="mt-3">
								<span class="h3">Description</span>
							</p>
						</b-col>
						<b-col xl="8" lg="8" sm="8">
							<b-form-group label-for="input-1">
								<b-form-input
									id="input-1"
									v-model="linkUpdateForm.desc"
									:state="descStatus"
								></b-form-input>
								<b-form-invalid-feedback :state="descStatus">
									Please enter a page description or functionality
								</b-form-invalid-feedback>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col xl="4" lg="4" sm="4">
							<p class="mt-3">
								<span class="h3">Icon</span>
							</p>
						</b-col>
						<b-col xl="8" lg="8" sm="8">
							<b-form-group>
								<b-input-group v-if="customIcon">
									<b-form-input
										type="text"
										v-model="linkUpdateForm.icon"
										:state="iconStatus"
										placeholder="ex. fa fa-globe"
									>
									</b-form-input>
									<template #append>
										<b-button
											title="Back to icon list"
											variant="danger"
											@click="
												customIcon = false;
												linkUpdateForm.icon = '';
											"
											>X
										</b-button>
									</template>
								</b-input-group>
								<b-form-select
									v-else
									v-model="linkUpdateForm.icon"
									:state="iconStatus"
									:options="iconOption"
									value-field="key"
									text-field="text"
									@change="handleIconChange()"
								>
								</b-form-select>
								<b-form-invalid-feedback :state="iconStatus">
									Please select or enter a valid font-awesome icon
								</b-form-invalid-feedback>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col xl="4" lg="4" sm="4">
							<p>
								<span class="h3">Icon Color</span>
							</p>
						</b-col>
						<b-col xl="8" lg="8" sm="8">
							<b-form-group>
								<b-input-group v-if="customColor">
									<b-form-input
										id="customIcon"
										type="text"
										v-model="linkUpdateForm.color"
										:state="colorStatus"
										placeholder="RGB(45, 206, 137) or a standard css)"
									>
									</b-form-input>
									<template #append>
										<b-button
											title="Back to color list"
											variant="danger"
											@click="
												customColor = false;
												linkUpdateForm.color = '';
											"
											>X
										</b-button>
									</template>
								</b-input-group>
								<b-form-select
									v-else
									v-model="linkUpdateForm.color"
									:state="colorStatus"
									:options="colorOption"
									value-field="key"
									text-field="text"
									:disabled="linkUpdateForm.type === ''"
									@change="handleIconChange(true)"
								>
								<template #first>
									<b-form-select-option class="text-center" disabled :key="null" value="first">Select an icon color</b-form-select-option>
								</template>
								<template>
									<span v-for="option in colorOption">
										<b-form-select-option v-if="option.key === 'custom'" key="custom" :value="option.key">
											{{ option.text }}
										</b-form-select-option>
										<b-form-select-option v-else :key="option.key" :value="option.key">
											{{ option.text }}
										</b-form-select-option>
									</span>
								</template>
								</b-form-select>
								<b-form-invalid-feedback v-if="!customIcon" :state="colorStatus">
									Please select an icon color
								</b-form-invalid-feedback>
								<b-form-invalid-feedback v-else :state="colorStatus">
									Please enter a valid css color
								</b-form-invalid-feedback>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col xl="4" lg="4" sm="4">
							<p class="mt-3">
								<span class="h3">Order</span>
							</p>
						</b-col>
						<b-col xl="8" lg="8" sm="8">
							<b-form-group label-for="input-1">
								<b-form-select
									id="linkOrder"
									v-model="linkUpdateForm.order"
									:options="orderOption"
									value-field="key"
									@change="handleOrderChange"
								>
								</b-form-select>
							</b-form-group>
						</b-col>
					</b-row>
				</b-form>
			</b-col>
			<b-col>
				<div class="w-100 d-flex justify-content-center align-items-center border preview-area">
					<b-row class="nav-link h-100">
						<h3 class="ml-3">{{ linkUpdateForm.group }}</h3>
						<ul>
							<span v-for="link in currentGrpLinks">
								<router-link
									v-if="link.id === linkUpdateForm.id"
									class="nav-link border border-dark"
									:href="linkUpdateForm.link"
									:to="linkUpdateForm.link"
									:title="`${origin}${linkUpdateForm.link}`"
								>
									<template>
										<i :class="`${linkUpdateForm.icon} pr-2`" :style="{color: linkUpdateForm.color}"></i>
										<span class="nav-link-text">{{ linkUpdateForm.name }}</span>
									</template>
								</router-link>
								<router-link
									v-else
									class="nav-link"
									:href="link.link"
									:to="link.link"
									:title="`${origin}${link.link}`"
								>
									<template>
										<i :class="`${link.icon} pr-2`" :style="{color: link.icon_color}"></i>
										<span class="nav-link-text">{{ link.name }}</span>
									</template>
								</router-link>
							</span>
						</ul>
					</b-row>
				</div>
			</b-col>
		</b-row>
		<b-row class="mt-3">
			<b-col cols="2">
				<p class="mt-3">
					<span class="h3">Roles</span>
				</p>
			</b-col>
			<b-col xl="4" lg="4" sm="4">
				<b-form-select value-field="key" v-model="roleSelection" :options="roleOption" multiple>
				</b-form-select>
			</b-col>
			<b-col xl="1" lg="1" sm="1" class="text-center">
				<b-row>
					<b-col xl="12" lg="12" sm="12">
						<span class="badge badge-pill badge-primary">
							<i class="fas fa-chevron-right p-2" @click="sendToNew"></i>
						</span>
					</b-col>
					<b-col class="mt-1" xl="12" lg="12" sm="12">
						<span class="badge badge-pill badge-primary" @click="sendToOld">
							<i class="fas fa-chevron-left p-2"></i>
						</span>
					</b-col>
				</b-row>
			</b-col>
			<b-col xl="4" lg="4" sm="4">
				<b-form-select
					:state="roleStatus"
					v-model="roleSelection"
					value-field="key"
					:options="linkUpdateForm.role"
					multiple
				>
				</b-form-select>
				<b-form-invalid-feedback :state="roleStatus"> Please select a role permission </b-form-invalid-feedback>
			</b-col>
		</b-row>
		<hr />
		<div class="mt-3 d-flex justify-content-between">
			<base-button type="white" title="Close" v-on:click="modalClose()"> Close </base-button>
			<base-button
				type="primary"
				:title="submitDisabled ? '' : 'Save'"
				:disabled="!submitDisabled"
				@click="updateLink"
				:loading="submitLoading"
			>
				Save
			</base-button>
		</div>
	</div>
</template>

<script>
import handleResponse from "../../common/directive/handlResponse";
import AuthService from "@/common/api-services/auth-service";
import ToastVue from "./Toast.vue";
import administratorService from "../../common/api-services/administrator-service";
import initService from "../../common/api-services/init-service";

export default {
	name: "Edit-Link-Simple",
	components: {ToastVue},
	computed: {
		submitDisabled() {
			return (
				this.changeStatus &&
				this.groupStatus &&
				this.typeStatus &&
				this.linkStatus &&
				this.nameStatus &&
				this.descStatus &&
				this.roleStatus &&
				this.iconStatus &&
				this.colorStatus
			);
		},
		changeStatus() {
			if (this.linkUpdateForm.role.length !== this.initialLinkUpdateForm.role.length) {
				return true;
			} else {
				this.initialLinkUpdateForm.role.map(role => {
					if (!this.linkUpdateForm.role.includes(role)) {
						return true;
					}
				})
				this.linkUpdateForm.role.map(role => {
					if (!this.initialLinkUpdateForm.role.includes(role)) {
						return true;
					}
				})
			}

			return JSON.stringify(this.linkUpdateForm) !== JSON.stringify(this.initialLinkUpdateForm);
		},
		nameStatus() {
			return this.linkUpdateForm.name.length > 0;
		},
		descStatus() {
			return this.linkUpdateForm.desc.length > 0;
		},
		typeStatus() {
			return this.linkUpdateForm.type.length > 0;
		},
		linkStatus() {
			return this.linkUpdateForm.link.length > 0;
		},
		groupStatus() {
			return this.linkUpdateForm.group.length > 0;
		},
		roleStatus() {
			return this.linkUpdateForm.role.length > 0;
		},
		iconStatus() {
			return this.linkUpdateForm.icon.length > 0;
		},
		colorStatus() {
			return this.linkUpdateForm.color.length > 0;
		},
	},
	data() {
		return {
			linkUpdateForm: {
				id: "",
				order: 1,
				group: "",
				type: "",
				link: "",
				role: [],
				icon: "",
				color: "",
				name: "",
				desc: "",
			},
			initialLinkUpdateForm: {
				id: "",
				order: 1,
				group: "",
				type: "",
				link: "",
				role: [],
				icon: "",
				color: "",
				name: "",
				desc: "",
			},
			roleSelection: [],
			groupOption: [],
			typeOption: [
				{key: "internal", text: "Internal"},
				{key: "external_iframe", text: "External - Iframe"},
				{key: "external_new-window", text: "External - New Window"},
			],
			roleOption: [],
			customIcon: false,
			iconOption: [
				{key: "fa fa-rss", text: "RSS"},
				{key: "fa fa-signal", text: "Signal"},
				{key: "fas fa-broadcast-tower", text: "Tower"},
				{key: "fa fa-power-off", text: "Power Off"},
				{key: "fa fa-exclamation-triangle", text: "Exlamation Triangle"},
				{key: "fa fa-redo-alt", text: "Redo"},
				{key: "fa fa-window-close", text: "Window Close"},
				{key: "fa fa-envelope", text: "Envelope"},
				{key: "fa fa-envelope-open", text: "Envelope Open"},
				{key: "fas fa-mail-bulk", text: "Bulk Mail"},
				{key: "fas fa-clipboard-check", text: "Clipboard Check"},
				{key: "fa fa-phone", text: "Phone"},
				{key: "fa fa-phone-square", text: "Phone Square"},
				{key: "fa fa-file-invoice", text: "Invoice"},
				{key: "fa fa-file-pdf", text: "File PDF"},
				{key: "fa fa-check-square", text: "Check Square"},
				{key: "fa fa-box", text: "Package"},
				{key: "fab fa-searchengin", text: "Search Engine"},
				{key: "fa fa-cog", text: "Cog"},
				{key: "fa fa-cogs", text: "Cogs"},
				{key: "fa fa-wrench", text: "Wrench"},
				{key: "fa fa-tools", text: "Tools"},
				{key: "fa fa-lock", text: "Lock"},
				{key: "fa fa-unlock", text: "Unlock"},
				{key: "fa fa-lock-open", text: "Lock Open"},
				{key: "fa fa-key", text: "Key"},
				{key: "fa fa-globe", text: "Globe"},
				{key: "fa fa-user", text: "User"},
				{key: "fa fa-users", text: "Users"},
				{key: "custom", text: "Custom Font Awesome Icon"},
	
			],
			customColor: true,
			colorOption: [
				// standard css colors
				{key: "cyan", text: "Cyan"},
				{key: "darkcyan", text: "Dark Cyan"},
				{key: "cornflowerblue", text: "Cornflower Blue"},
				{key: "darkturquoise", text: "Dark Turquoise"},
				{key: "deepskyblue", text: "Deep Sky Blue"},
				{key: "darkblue", text: "Dark Blue"},
				{key: "purple", text: "Purple"},
				{key: "deeppink", text: "Deep Pink"},
				{key: "yellow", text: "Yellow"},
				{key: "darkgoldenrod", text: "Dark Goldenrod"},
				{key: "RGB(45, 206, 137)", text: "Green"},
				{key: "chartreuse", text: "Bright Green"},
				{key: "darkgreen", text: "Dark Green"},
				{key: "burlywood", text: "Burly Wood"},
				{key: "red", text: "Red"},
				{key: "crimson", text: "Crimson"},
				{key: "darkred", text: "Dark Red"},
				{key: "orange", text: "Orange"},
				{key: "darkorange", text: "Dark Orange"},
				{key: "darkslategray", text: "Dark Slate Gray"},
				{key: "darkgray", text: "Dark Gray"},
				{key: "black", text: "Black"},
				// {key: "custom", text: "Custom Color"},
			],
			orderOption: [],
			submitLoading: false,
			origin: "",
			groupLinks: [],
			currentGrpLinks: [],

		};
	},
	mounted() {
		this.origin = window.location.origin;
		this.getGroups();
		this.getRoles();
		this.$root.$on("editLink", link => {
			this.linkUpdateForm = {
				id: link.id,
				order: link.order ? link.order : 1,
				group: link.group ? link.group : "",
				type: link.type ? link.type : "",
				link: link.link ? link.link : "",
				role: link.role ? link.role : [],
				icon: link.icon ? link.icon : "",
				color: link.color ? link.color : "",
				name: link.name ? link.name : "",
				desc: link.desc ? link.desc : "",
			};
			this.initialLinkUpdateForm = structuredClone(this.linkUpdateForm);
			if (!JSON.stringify(this.iconOption).includes(link.icon)) {
				this.customIcon = true;
			}
			this.colorOption.map(color => {
				if (color.key === link.color) {
					this.customColor = false;
				}
			});
			this.roleOption = this.roleOption.filter(role => {
				return !this.linkUpdateForm.role.includes(role.key);
			});
			this.roleSelection = link.role ? link.role : [];
			this.getCarrierLinks(link.group);
		});
	},
	methods: {
		async updateLink() {
			this.submitLoading = true;
			let data = {
				id: this.linkUpdateForm.id,
				order: this.linkUpdateForm.order,
				group: this.linkUpdateForm.group,
				attr_type: this.linkUpdateForm.type,
				link: this.linkUpdateForm.link,
				role: String(this.linkUpdateForm.role),
				icon: this.linkUpdateForm.icon,
				icon_color: this.linkUpdateForm.color,
				name: this.linkUpdateForm.name,
				description: this.linkUpdateForm.desc,
			};

			AuthService.updateMenuLink(data)
				.then(response => {
					// console.log(response);
					let {type, msg} = handleResponse.apiResponse(response);
					if (type === "success") {
						this.$root.$emit("refreshMenuLinks");
						this.modalClose();
						this.$toast.success("Link updated successfully");
					} else {
						console.error(msg);
						this.$toast.error(msg);
					}
				})
				.catch(error => {
					let {type, msg} = handleResponse.handleError(error);
					console.error(error);
					this.$toast.error(msg, {
						component: ToastVue,
						title: "Error",
					});
				})
				.finally(() => {
					this.submitLoading = false;
				});
		},

		async getCarrierLinks() {
			// console.log(this.linkUpdateForm);
			let links = this.$store.getters["getLinksByGroup"](this.linkUpdateForm.group);
				try {
					if (links) {
						this.currentGrpLinks = links;

						// build order options
						links.map((link, index) => {
							// console.log(link.name, link.order)
							if (index === 0) {
								this.orderOption.push({key: 1, text: "First"});
							} else if (index === links.length - 1) {
								this.orderOption.push({key: index + 1, text: "Last"});
							} else {
								this.orderOption.push({key: link.order, text: link.order});
							}
						});
					} else {
						this.currentGrpLinks = [];
					}

					this.getGroupLinks();
				}
				catch (error) {
					console.error(error);
				}
		},

		async getGroupLinks() {
			this.groupLinks = [];
			// console.log("getGroupLinks", this.linkUpdateForm.group);
			// console.log("currentGrpLinks", this.currentGrpLinks);
			let routerLinks = this.$router.getRoutes();
			routerLinks.filter(route => {
				if (route.parent && route.parent.name !== "Authentication" && route.parent.name !== "Error Layout") {
					if (route.parent.name === this.linkUpdateForm.group) {
						let item = {
							label: `${route.name} - ${route.path}`,
							name: route.name,
							url: route.path,
							group: route.parent.name,
							icon: "",
							color: "",
						};
						if (route.path && !JSON.stringify(this.currentGrpLinks).includes(route.path)) {
							this.groupLinks.push(item);
						} else if (route.path === this.linkUpdateForm.link) {
							this.groupLinks.push(item);
						}
					}
				}
			});
		},

		getGroups() {
			let routerLinks = this.$router.getRoutes();
			routerLinks.filter(route => {
				if (route.parent && route.parent.name !== "Authentication" && route.parent.name !== "Error Layout") {
					if (!JSON.stringify(this.groupOption).includes(route.parent.name)) {
						this.groupOption.push({key: route.parent.name, text: route.parent.name});
					}
				}
			});
		},

		getRoles() {
			let customer = initService.getCustomerInfo();
			administratorService.getGroupList().then(res => {
				res.map((item, index) => {
					let name = String(item.GroupName).toUpperCase();
					// console.log('group:'+name,item);
					if (this.linkUpdateForm.role.includes(name)) return;
					if (name.includes("CARRIER_") && !name.includes(`CARRIER_${customer.toUpperCase()}`) && !name.includes("ADMIN")) return;
					// if (name.includes("CARRIER_")) name = name.replace("CARRIER_", "");
					this.roleOption.push({key: item.GroupName, text: name});
				});
			});
		},

		sendToNew() {
			// console.log(this.roleSelection);

			this.roleOption = this.roleOption.filter(role => {
				return !this.roleSelection.includes(role.key);
			});
			this.roleSelection.map(role => {
				if (!this.linkUpdateForm.role.includes(role)) {
					this.linkUpdateForm.role.push(role.toUpperCase());
				}
			});
		},

		sendToOld() {
			// console.log(this.roleSelection);
			this.roleSelection.map(role => {
				this.linkUpdateForm.role = this.linkUpdateForm.role.filter(item => {
					return item !== role;
				});
			});
			this.roleSelection.map(role => {
				this.roleOption.push({key: role, text: role.toUpperCase()});
			});
		},

		handleRouteChange() {
			this.groupLinks.map(route => {
				if (route.url === this.linkUpdateForm.link) {
					this.linkUpdateForm.group = route.group;
					this.linkUpdateForm.type = "internal";
					this.linkUpdateForm.name = route.name;
				}
			});
		},

		handleTypeChange() {
			if (this.linkUpdateForm.type === "internal") {
				this.linkUpdateForm.link = "";
			}
		},

		handleIconChange(color_change = false) {
			if (color_change) {
				if (this.linkUpdateForm.color === "custom") {
					this.customColor = true;
					this.linkUpdateForm.color = "";
				} else {
					this.customColor = false;
				}
			} else {
				if (this.linkUpdateForm.icon === "custom") {
					this.customIcon = true;
					this.linkUpdateForm.icon = "";
				} else {
					this.customIcon = false;
				}
			}
		},

		handleOrderChange() {
			// Convert the updated order to a number
			this.linkUpdateForm.order = parseInt(this.linkUpdateForm.order);

			// Find the original order value of the updated link
			let originalOrder;
			for (let link of this.currentGrpLinks) {
				if (link.id === this.linkUpdateForm.id) {
					originalOrder = link.order;
					break;
				}
			}

			// Update the order values of the links
			this.currentGrpLinks.forEach((link, index) => {
				if (link.id === this.linkUpdateForm.id) {
					this.currentGrpLinks[index].order = this.linkUpdateForm.order;
				} else if (originalOrder < this.linkUpdateForm.order) {
					// If the updated link's order increased, decrement the order values of links in between
					if (link.order > originalOrder && link.order <= this.linkUpdateForm.order) {
						this.currentGrpLinks[index].order--;
					}
				} else if (originalOrder > this.linkUpdateForm.order) {
					// If the updated link's order decreased, increment the order values of links in between
					if (link.order >= this.linkUpdateForm.order && link.order < originalOrder) {
						this.currentGrpLinks[index].order++;
					}
				}
			});

			// Sort the links by their order values
			this.currentGrpLinks.sort((a, b) => a.order - b.order);
		},

		modalClose() {
			this.$bvModal.hide("edit-link");
		},
	},
};
</script>
<style scoped>
.preview-area {
	height: 400px;
	overflow-x: scroll;
}
</style>
